import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import useStore from "../store/useStore";
import Navbar from "../components/navbar";
import Footer from "../components/footer";
import Switcher from "../components/switcher";
import EventDetailContent from "../components/EventDetailContent";

export default function EventDetail() {
  const { id } = useParams();
  const { eventos, fetchEventos } = useStore();

  useEffect(() => {
    fetchEventos();
  }, [fetchEventos]);
  console.log("Eventos:", eventos);

  // Buscar el evento por id
  const evento = (eventos || []).find((item) => String(item.id) === String(id));

  if (!evento) {
    return (
      <>
        <Navbar />
        <div className="container h-screen py-24 text-center">
          <h2 className="text-2xl font-bold">Cargando o no encontrado...</h2>
        </div>
        <Footer />
        <Switcher />
      </>
    );
  }

  return (
    <>
      <header>
        <Navbar />
      </header>
      <main>
        <EventDetailContent evento={evento} />
      </main>
      <footer>
        <Footer />
      </footer>
      <Switcher />
    </>
  );
}
